import { Avatar, Tooltip } from 'antd';
import React from 'react';

const MAX_AVATARS = 5;

function initials(name) {
	const parts = String(name || '')
		.trim()
		.split(/\s+/)
		.filter(Boolean);
	if (!parts.length) {
		return '?';
	}
	return parts
		.slice(0, 2)
		.map((word) => word.charAt(0).toUpperCase())
		.join('');
}

function membersOf(channel) {
	const fields = channel.QUEUE_USERS_FIELDS;
	if (!fields || typeof fields !== 'object') {
		return { shown: [], total: 0 };
	}
	const ids = Array.isArray(channel.QUEUE) ? channel.QUEUE : Object.keys(fields);
	const shown = ids
		.map((id) => (fields[id] ? { id, ...fields[id] } : null))
		.filter(Boolean)
		.slice(0, MAX_AVATARS);
	return { shown, total: ids.length };
}

export default function ChannelMembers({ channel }) {
	const { shown, total } = membersOf(channel);
	if (!shown.length) {
		return null;
	}
	const extra = Math.max(total - MAX_AVATARS, 0);
	return (
		<span className="channel-members">
			{shown.map((member) => (
				<Tooltip key={member.id} title={member.USER_NAME || undefined}>
					<Avatar
						size={28}
						src={member.USER_AVATAR || undefined}
						alt={member.USER_NAME || ''}
						className="channel-member"
					>
						{initials(member.USER_NAME)}
					</Avatar>
				</Tooltip>
			))}
			{extra > 0 ? (
				<Avatar size={28} className="channel-member channel-member-extra">
					+{extra}
				</Avatar>
			) : null}
		</span>
	);
}
